import PropTypes from 'prop-types';
import React from 'react';
import styles from './NameRow.css';

class NameRow extends React.Component {
  render() {
    const { label, value } = this.props;
    return (
      <div className="row">
        <div className="col-lg-12 box-divider">
          <div className="form-group col-sm-12 label-section">
            <label className={styles.label}>{label}</label>
            <div className={`${styles.value} pull-right`}>{value}</div>
          </div>
        </div>
      </div>
    );
  }
}

NameRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export default NameRow;
